import AuthGate from '../../../components/feature/AuthGate';

const BottomCTA = () => {
  return (
    <section className="py-16 sm:py-24 lg:py-32 bg-gradient-to-br from-dark via-dark-lighter to-dark relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgxNiwgMTg1LCAxMjksIDAuMSkiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-30"></div>
      
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[300px] sm:w-[400px] lg:w-[600px] h-[300px] sm:h-[400px] lg:h-[600px] bg-gradient-to-r from-emerald/20 to-emerald-light/20 rounded-full blur-3xl animate-pulse-slow"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 text-center relative z-10">
        <h2 className="text-2xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-beige-light mb-6 sm:mb-8 leading-tight">
          <span className="block sm:inline">Piyasayı Karmaşık Grafiklerle Değil,</span>
          <br className="hidden sm:block" />
          <span className="bg-gradient-to-r from-emerald to-emerald-light bg-clip-text text-transparent">
            Net Kararlarla Takip Et.
          </span>
        </h2>

        <p className="text-base sm:text-lg lg:text-xl text-beige/70 mb-8 sm:mb-10 lg:mb-12 max-w-3xl mx-auto px-4">
          BAGA ile yatırım kararlarınızı daha hızlı ve bilinçli alın. Gerçek zamanlı karar akışına şimdi erişin.
        </p>

        <AuthGate>
          {(handleClick) => (
            <button
              onClick={handleClick}
              className="inline-flex items-center gap-2 sm:gap-3 bg-emerald hover:bg-emerald-light text-beige-light px-8 sm:px-10 lg:px-12 py-4 sm:py-5 rounded-full text-base sm:text-lg font-bold transition-all hover:shadow-2xl hover:shadow-emerald/50 hover:scale-105 animate-pulse whitespace-nowrap cursor-pointer"
            >
              Canlı Kararları Aç
              <i className="ri-arrow-right-line text-xl sm:text-2xl"></i>
            </button>
          )}
        </AuthGate>

        <div className="mt-10 sm:mt-12 lg:mt-16 grid grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-3xl mx-auto">
          <div className="text-center">
            <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-emerald mb-1 sm:mb-2">500+</div>
            <div className="text-beige/70 text-xs sm:text-sm">Takip Edilen Hisse</div>
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-emerald mb-1 sm:mb-2">7/24</div>
            <div className="text-beige/70 text-xs sm:text-sm">Kesintisiz Tarama</div>
          </div>
          <div className="text-center">
            <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-emerald mb-1 sm:mb-2">&lt;1sn</div>
            <div className="text-beige/70 text-xs sm:text-sm">Karar Üretim Süresi</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BottomCTA;
